import { StyleSheet } from 'react-native';
import { Spacing } from 'src/theme-v2/spacing';

export const style = StyleSheet.create({
  contentWrapper: {
    gap: Spacing.Compact,
  },
});
